// Helper d'invocation des Edge Functions OIDC — mutualise URL, headers et gestion d'erreur.
// Même pattern que resendEmailService : fetch vers /functions/v1/ avec l'anon key.

const SUPABASE_URL =
  import.meta.env.VITE_SUPABASE_URL || 'https://ezjthfrjbqwpxrksijml.supabase.co';
const SUPABASE_ANON_KEY = import.meta.env.VITE_SUPABASE_ANON_KEY || '';

/**
 * POST vers une Edge Function Supabase et retourne le JSON typé.
 * @throws Error avec le message renvoyé par la fonction en cas d'échec
 */
export async function invokeOidcFunction<T>(
  functionName: string,
  body: Record<string, unknown>,
): Promise<T> {
  const response = await fetch(`${SUPABASE_URL}/functions/v1/${functionName}`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      apikey: SUPABASE_ANON_KEY,
      Authorization: `Bearer ${SUPABASE_ANON_KEY}`,
    },
    body: JSON.stringify(body),
  });

  const data = await response.json().catch(() => ({}));

  if (!response.ok) {
    console.error(`${functionName} error:`, response.status, data);
    throw new Error(data.error || `Erreur ${functionName} (HTTP ${response.status})`);
  }

  return data as T;
}
